document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.js-product-grid');
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll('.product-card'));
  const filters = Array.from(document.querySelectorAll('.filter-btn'));
  const search = document.querySelector('.js-product-search');
  let activeFilter = 'all';

  function applyFilters() {
    const term = (search?.value || '').trim().toLowerCase();

    cards.forEach((card) => {
      const title = card.dataset.title || card.textContent.toLowerCase();
      const collections = card.dataset.collections || '';
      const isOffer = card.dataset.offer === 'true';
      const matchesText = !term || title.includes(term);
      const matchesFilter =
        activeFilter === 'all' ||
        (activeFilter === 'offers' && isOffer) ||
        collections.split(' ').includes(activeFilter);

      card.hidden = !(matchesText && matchesFilter);
    });
  }

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.filter;
      filters.forEach((item) => item.classList.toggle('active', item === button));
      applyFilters();
    });
  });

  search?.addEventListener('input', applyFilters);
});
document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('.product-thumbnail');
  if (!thumbnail) return;

  const gallery = thumbnail.closest('.product-gallery');
  const mainImage = gallery?.querySelector('.product-main-image img');
  const newImage = thumbnail.dataset.image;

  if (mainImage && newImage) {
    mainImage.src = newImage;
    mainImage.srcset = '';
  }
});
